import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './ProjectSlide.css';
import { HashLink } from 'react-router-hash-link';
//   "id": 2,
// "image": "budding-bar.png",
// "alt": "Budding Bar",
// "title": "Budding Bar Slide 2",
// "richText": "React SPA & Custom Menu Integration"

// Slides have image on left and details on right, in mobile image is on top and details on bottom
// return to home button

interface ProjectSlideProps {
    id: number;
    image: string;
    alt: string;
    title: string;
    richText: string;
    project: any;
    onPrevious: () => void;
    onNext: () => void;
    previousTitle?: string;
    nextTitle?: string;
}
const ProjectSlide = (props: ProjectSlideProps) => {
    const [prevHovered, setPrevHov] = React.useState(false);
    const [nextHovered, setNextHov] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 800);
    const detailsRef = React.useRef<HTMLDivElement | null>(null);
    const baseUrl = process.env.PUBLIC_URL || window.location.origin + '/';

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const setPrevHovered = (hovered: boolean, delay: number = 0) => {
        if (!isMobile) {
            setTimeout(() => {
                setPrevHov(hovered);
            }, delay);
        }
    };

    const setNextHovered = (hovered: boolean, delay: number = 0) => {
        if (!isMobile) {
            setTimeout(() => {
                setNextHov(hovered);
            }, delay);
        }
    };

    React.useEffect(() => {
        setPrevHov(isMobile);
        setNextHov(isMobile);
    }, [isMobile]);

    React.useEffect(() => {
        if (detailsRef.current) {
            detailsRef.current.scrollTop = 0;
        }
    }, [props.id]);
    
    return <div className="project-slide">
        <HashLink to="/#projects" className="back-to-projects">
            <span className="arrow">←</span>
            <span>All Projects</span>
        </HashLink>

        <div className="project-slide-image">
            <img src={baseUrl + props.image} alt={props.alt} loading="eager" fetchPriority="high" />
        </div>
        <div className="project-navigation">
            <button 
                onClick={props.onPrevious} 
                className="nav-button prev"
                onMouseEnter={() => setPrevHovered(true)}
                onMouseLeave={() => setPrevHovered(false, 0)}
            >
                <span className="arrow">←</span>
                {prevHovered && <span className="nav-title">{props.previousTitle}</span>}
            </button>
            <button 
                onClick={props.onNext} 
                className="nav-button next"
                onMouseEnter={() => setNextHovered(true)}
                onMouseLeave={() => setNextHovered(false, 0)}
            >
                {nextHovered && <span className="nav-title">{props.nextTitle}</span>}
                <span className="arrow">→</span>
            </button>
        </div>
        <div className="project-slide-details" ref={detailsRef}>
            <div className="project-header">
                <h1 className="project-name">{props.project.name}</h1>
                <p className="project-description">{props.project.description}</p>
                <ul className="project-skills">
                    {props.project.skills.map((skill: string, index: number) => (
                        <li key={index}>{skill}</li>
                    ))}
                </ul>
            </div>
            <h1>{props.title}</h1>
            <div className="project-slide-description" dangerouslySetInnerHTML={{ __html: props.richText }} />
            <button 
                className="visit-website-button"
                onClick={() => window.open(props.project.link, '_blank')}
            >
                Visit Website
            </button>
        </div>

    </div>;
};
export default ProjectSlide;